import { render, staticRenderFns } from "./specialCategoryEditor.vue?vue&type=template&id=435edee4&scoped=true"
import script from "./specialCategoryEditor.vue?vue&type=script&lang=js"
export * from "./specialCategoryEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435edee4",
  null
  
)

export default component.exports